import React from 'react';
import {Form} from 'formik';
import classnames from 'classnames';
import FormTitle from "../FormTitle";
import FieldInput from 'common/components/FieldInput';
import ButtonsSubmitCancel from '../ButtonsSubmitCancel';
import FieldSelect from 'common/components/FieldSelect';
import FieldTextareaAutosize from 'common/components/FieldTextareaAutosize';
import UploadingFilePopUp from 'common/components/UploadingFilePopUp/UploadingFilePopUp';
import GovmapImagePopup from '../GovmapImagePopup';
import FieldCheckbox from '../../../../common/components/FieldCheckbox';
import MultipleTooltip from '../../../../common/components/MultipleTooltip';
import ButtonTextSuggestions from '../../../../common/components/ButtonTextSuggestions';
import ModalSharedFilesList from "../../../../common/components/ModalSharedFilesList";
import FieldSelectMulti from "../../../../common/components/FieldSelectMulti";
import ModalApiConfirmationImage from "../ModalApiConfirmationImage";
import example from "../../../../common/assets/mock/files_small/file_small_1.jpg";
import MarkFileUploaded from "../../../../common/components/MarkFileUploaded";
import FieldPasteFile from '../../../../common/components/FieldPasteFile';
import FieldPasteImage from "../../../../common/components/FieldPasteImage";
import ListUploadedFilesViewDelete from "../ListUploadedFilesViewDelete";
import browser from 'common/assets/open_in_browser-24px.svg';
import {envDevelopmentLevel} from "../../constants/textSuggestions";
import styles from './styles.module.scss';

const Form_4View = ({
                      shumaID,
                      stepID,
                      values,
                      setFieldValue,
                      prevPagePath,
                      nextPagePath,
                      options,
                      fileUploaded,
                      onFileSelected,
                      fileTypeIds,
                      showUploadingFilePopUp,
                      progress,
                      mapPosition,
                      stepData: {
                        apiExists,
                        gisLink
                      },
                      fileSelectOptions: {
                        environmentLocatorMap,
                        idfLocatingPlot,
                      },
                      filesListData
                    }) => {
  const mapLink = 'https://www.govmap.gov.il/';
  const condition = values.landSurroundings ? (values.landSurroundings.map(item => item.value)).join() : '';

  return (
    <div className={styles.form_4}>
      <FormTitle title={'תיאור הסביבה'}/>
      <Form>
        <FieldTextareaAutosize
          fieldId="propertyLocationDesc"
          value={values.propertyLocationDesc}
          label={'מיקום הנכס'}
          containerCustomStyles={styles.marginBottom25}
        />
        <div className={classnames(styles.unit, styles.marginBottom25)}>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldInput
              fieldId="street"
              value={values.street}
              label={'שם רחוב'}
              disabled={true}
              containerCustomStyles={styles.halfField}
            />
            <FieldInput
              fieldId="neighborhoodName"
              value={values.neighborhoodName}
              label={'שם שכונה/מיקום יחסי'}
              containerCustomStyles={styles.halfField}
            />
          </div>
          <FieldTextareaAutosize
            fieldId="areaLimits"
            value={values.areaLimits}
            label={(
              <div className={styles.labelWrapper}>
                <span>גבולות המתחם</span>
                <MultipleTooltip
                  id={'areaLimitsTooltip'}
                  customIconClassName={styles.tooltip}
                  label={'לדוגמה -הרצל בצפון, ויצמן במערב, הדקל בדרום והנשיאים במזרח'}
                />
              </div>
            )}
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="streetMainUsage"
            value={values.streetMainUsage}
            label={'שימוש עיקרי ברחוב'}
            containerCustomStyles={styles.marginBottom25}
          />
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldSelect
              fieldId="buildType"
              label={'אופי הבנייה'}
              options={options.buildTypeOptions}
              containerStyles={styles.halfField}
            />
            <FieldSelect
              fieldId="buildPeriod"
              label={'תקופת הבנייה'}
              options={options.buildPeriodOptions}
              containerStyles={styles.halfField}
            />
          </div>
          <FieldTextareaAutosize
            fieldId="areaUniqueFeatures"
            value={values.areaUniqueFeatures}
            label={(
              <div className={styles.labelWrapper}>
                <span>מאפיינים ייחודיים לסביבה</span>
                <MultipleTooltip
                  id={'areaUniqueFeaturesTooltip'}
                  customIconClassName={styles.tooltip}
                  label={'לדוגמא: התחדשות עירונית/שצ"פ/שב"צ/בתי עלמין/מתע"ן'}
                />
              </div>
            )}
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="envDevelopmentLevel"
            value={values.envDevelopmentLevel}
            label={(
              <div className={styles.labelWrapper}>
                  <span>
                    <span className={styles.mandatoryMark}>*</span>
                    רמת פיתוח סביבתי
                  </span>
                <MultipleTooltip
                  id={'envDevelopmentLevelTooltip'}
                  customIconClassName={styles.tooltip}
                  label={'לדוגמא: פיתוח סביבתי מלא. במועד הביקור נערכו עבודות פיתוח ברחוב'}
                />
                <ButtonTextSuggestions
                  fieldName={'envDevelopmentLevel'}
                  currentFieldValue={values.envDevelopmentLevel}
                  textSuggestionsArray={envDevelopmentLevel}
                  setFieldValue={setFieldValue}
                />
              </div>
            )}
            containerCustomStyles={styles.marginBottom25}
          />
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldSelect
              fieldId="facing"
              label={'פאת רחוב'}
              options={options.facingOptions}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="streetLocation"
              label={'מיקום רחוב'}
              options={options.streetLocationOptions}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="streetType"
              label={'סוג רחוב'}
              options={options.streetTypeOptions}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="streetTraffic"
              label={'תנועה ברחוב'}
              options={options.streetTrafficOptions}
              containerStyles={styles.quarterField}
            />
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersRow)}>
            <FieldCheckbox
              fieldId="parkingIssues"
              label="מצוקת חניה"
              value={values.parkingIssues}
              containerStyles={styles.quarterField}
            />
            <FieldCheckbox
              fieldId="publicTransport"
              label="תחבורה ציבורית ברחוב"
              value={values.publicTransport}
              containerStyles={styles.halfField}
            />
          </div>
          {values.parkingIssues &&
            <FieldSelect
              fieldId="parkingIssuesTimes"
              mandatoryMark={true}
              label={'זמני מצוקת חניה'}
              options={options.parkingIssuesTimesOptions}
              containerStyles={classnames(styles.halfField, styles.marginBottom25)}
            />
          }
          <FieldTextareaAutosize
            fieldId="adjacentStreets"
            value={values.adjacentStreets}
            label={(
              <div className={styles.labelWrapper}>
                <span>גבולות האזור</span>
                <MultipleTooltip
                  id={'adjacentStreetsTooltip'}
                  label={`מצפון -\nמדרום -\nממזרח -\nממערב -`}
                  customIconClassName={styles.tooltip}
                  customTooltipClassName={styles.adjacentStreetsTooltip}
                />
              </div>
            )}
            containerCustomStyles={styles.marginBottom25}
          />
        </div>
        <div className={styles.form_4_addFiles}>
          <h3 className={styles.subheader}>קובץ מפת איתור סביבה</h3>
          <FieldCheckbox fieldId={'fileType2Switch'}/>
          <div className={styles.autoAcceptInteract}>
            {environmentLocatorMap.type && (
              <>
                <ModalSharedFilesList file={environmentLocatorMap} shumaID={shumaID} stepID={stepID}/>
                <div className={styles.divideLine}/>
              </>
            )}
            <GovmapImagePopup
              buttonLabel={'הפק'}
              address={mapPosition}
              onFileApproved={onFileSelected(fileTypeIds.environmentLocatorMap)}
            />
            <div className={styles.divideLine}/>
            <a
              href={mapLink}
              className={styles.openSeparateTabButton}
              target="_blank"
              rel="noreferrer"
            >
              <img src={browser} className={styles.iconOpenInBrowser} alt="i"/>
              <div>אתר</div>
            </a>
            <div className={styles.addFileButton}>
              {!values.fileType2Switch
                ? (
                  <FieldPasteFile
                    fieldId={'environmentLocatorMapFileUploaded'}
                    fileUploaded={fileUploaded.environmentLocatorMapFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.environmentLocatorMap)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId={'environmentLocatorMapFileUploaded'}
                    fileUploaded={fileUploaded.environmentLocatorMapFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.environmentLocatorMap)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
              {(fileUploaded.environmentLocatorMapFileUploaded) && <MarkFileUploaded/>}
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.environmentLocatorMap}
            shumaId={shumaID}
          />
        </div>
        <div className={styles.marginBottom65}>
          <h3 className={styles.subheader}>קרקע</h3>
          <FieldSelectMulti
            fieldId="landSurroundings"
            options={options.landSurroundingsOptions}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isClearable={false}
            label={'גבולות החלקה'}
            containerStyles={styles.marginTopBottom}
          />
          {condition.includes('9') &&
            <FieldTextareaAutosize
              fieldId="landSurroundingsText"
              value={values.landSurroundingsText}
              mandatoryMark={true}
              label={'פירוט גבולות החלקה'}
              containerCustomStyles={styles.marginBottom25}
            />
          }
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldInput
              fieldId="buildingNearbyHazard"
              value={values.buildingNearbyHazard}
              label='מפגעים גובלים'
              containerCustomStyles={styles.halfField}
            />
            <FieldSelect
              fieldId="landShape"
              label={'צורת חלקה'}
              options={options.landShapeOptions}
              containerStyles={styles.halfField}
            />
          </div>
          <FieldTextareaAutosize
            fieldId={'landDescription'}
            value={values.landDescription}
            label={'תיאור מגרש'}
            containerCustomStyles={styles.marginBottom25}
          />
          <div className={styles.marginBottom25}>
            <h4 className={styles.subheader}>קובץ תצ"א לאיתור חלקה</h4>
            <FieldCheckbox fieldId={'fileType8Switch'} />
            <div className={styles.autoAcceptInteract}>
              {idfLocatingPlot.type &&
                <>
                  <ModalSharedFilesList file={idfLocatingPlot} shumaID={shumaID} stepID={stepID}/>
                  <div className={styles.divideLine}/>
                </>
              }
              {apiExists && <ModalApiConfirmationImage img={example} buttonLabel={'הפק'}/>}
              {apiExists && <div className={styles.divideLine}/>}
              {gisLink &&
                <a
                  href={gisLink ?? 'about:blank'}
                  className={styles.openSeparateTabButton}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={browser} className={styles.iconOpenInBrowser} alt="i"/>
                  <div>אתר</div>
                </a>
              }
              <div className={styles.addFileButton}>
                {!values.fileType8Switch
                  ? (
                    <FieldPasteFile
                      fieldId={'IDFLocatingPlotFileUploaded'}
                      fileUploaded={fileUploaded.IDFLocatingPlotFileUploaded}
                      onFileSelected={onFileSelected(fileTypeIds.idfLocatingPlot)}
                      setFieldValue={setFieldValue}
                    />
                  )
                  : (
                    <FieldPasteImage
                      fieldId={'IDFLocatingPlotFileUploaded'}
                      fileUploaded={fileUploaded.IDFLocatingPlotFileUploaded}
                      onFileSelected={onFileSelected(fileTypeIds.idfLocatingPlot)}
                      setFieldValue={setFieldValue}
                      formFields={'onlyFreeText'}
                    />
                  )
                }
                {(fileUploaded.IDFLocatingPlotFileUploaded) && <MarkFileUploaded/>}
              </div>
            </div>
            <ListUploadedFilesViewDelete
              data={filesListData}
              fileTypeID={fileTypeIds.idfLocatingPlot}
              shumaId={shumaID}
            />
          </div>
        </div>
        <ButtonsSubmitCancel prevPagePath={prevPagePath} nextPagePath={nextPagePath}/>
      </Form>
      <UploadingFilePopUp
        showUploadingFilePopUp={showUploadingFilePopUp}
        progress={progress}
        message="הקובץ נטען, אנא המתינו"
      />
    </div>
  );
};

export default Form_4View;